/* eslint-disable @typescript-eslint/no-explicit-any */
import { isString } from 'lodash';

const indexDisplay = ['eventIndex', 'ticketIndex', 'both'] as const;

export type IndexDisplay = (typeof indexDisplay)[number];

export const parseIndexDisplay = (data: any) => {
  return (
    isString(data) && indexDisplay.includes(data as any) ? data : indexDisplay[0]
  ) as IndexDisplay;
};
